import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import { Input } from 'components/common/FormElements/Input'

const KeepInContact = ({ form, label, ...props }) =>
  <React.Fragment>
    <Field
      { ...props }
      { ...form.keepInContact }
      innerProps={{ checkboxInputProps: { 'data-at-register-keepincontact-checkbox': true }}}
      component={ Input }
      label={ label } />
  </React.Fragment>

KeepInContact.propTypes = {
  form: PropTypes.shape({
    keepInContact: PropTypes.shape()
  }),
  label: PropTypes.string
}

export default KeepInContact
